// extracted by mini-css-extract-plugin
export default {"overlay":"_26Vdr","root":"_1Ql6S","modal":"TKBYt","continue":"_3UjSR","close":"_25dIu"};